var nurseslounge_lounge_header = {
    init:function($params, $module, $submodule){
        $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
        nurseslounge_lounge_header.followers($params, $module, $submodule)
    },
    followers:function($params, $module, $submodule){
        var $followButton = $("#nurseslounge-lounge .follow-button");
        $followButton.unbind().click(function(){
            nurseslounge_lounge_header.followers_request($params, function($data){
                if($data.status == 'success') {
                    nurseslounge_lounge_header.followers_reload($params, $module, $submodule);
                }else{
                    router.navigate('/lounges');
                }
            })
        });
        libs.memorySave('nurseslounge_lounge_header', {
            params:$params,
            module:$module,
            submodule:$submodule
        });
    },
    followers_request:function($params, cback){
        $.ajax({
            url: "/lounge/header/followers/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    followers_reload:function($params, $module, $submodule){
        libs.refreshBoxFrom('.top-nav-menu', $params, function () {
            nurseslounge_lounge.submenu($params, function(){
                if($module && $submodule){
                    eval($module + '.' + $submodule +'($params)');
                }
                if($("#nurseslounge-lounge-followers").length > 0){
                    nurseslounge_lounge_followers.init($params);
                }
            });
        });
    },
    followers_reload_last:function(){
        var $nursesloungeLoungeHeader = libs.memoryGet('nurseslounge_lounge_header');
        if($nursesloungeLoungeHeader){
            nurseslounge_lounge_header.followers_reload($nursesloungeLoungeHeader.params, $nursesloungeLoungeHeader.module, $nursesloungeLoungeHeader.submodule);
        }
    }
};
